import classNames from 'classnames';
import React, {useEffect} from 'react';

import {useI18n} from '@udemy/i18n';
import {ExpressiveIcon} from '@udemy/icons-expressive';

import {EnrolledCourses} from '../types/enrolledCourses';
import styles from './assertions-page.module.less';

interface PreparationSummaryProps {
    courses: EnrolledCourses[];
}

export const PreparationSummary = ({courses}: PreparationSummaryProps) => {
    const {gettext} = useI18n();
    const [minuttesOfLearning, setMinuttesOfLearning] = React.useState(0);
    const [learningActivitiesTaken, setLearningActivitiesTaken] = React.useState(0);

    useEffect(() => {
        if (courses) {
            const minutesOfLearning = courses.reduce((sum, course) => {
                return sum + (course.minutes_consumed ?? 0);
            }, 0);
            setMinuttesOfLearning(minutesOfLearning);
            setLearningActivitiesTaken(courses.length);
        }
    }, [courses]);

    return (
        <div
            data-testid="preparation-summary-container"
            className={classNames(styles['preparation-summary-container'])}
        >
            <div className={classNames(styles['preparation-summary-item-container'])}>
                <div className={classNames(styles['preparation-summary-item'])}>
                    <div className={classNames(styles['preparation-summary-item-icon'])}>
                        <ExpressiveIcon
                            name={'learner'}
                            size={'medium'}
                            className={styles['expressive-icon']}
                        />
                    </div>
                    <div className={classNames(styles['preparation-summary-item-text'])}>
                        <span className="ud-heading-xxl" data-purpose={'minutes-of-learning'}>
                            {minuttesOfLearning}
                        </span>
                        {/* TODO: check for the spacing*/}
                        <span className="ud-text-md">{gettext('Minutes of learning')}</span>
                    </div>
                </div>
                <div className={classNames(styles['preparation-summary-item'])}>
                    <div className={classNames(styles['preparation-summary-item-icon'])}>
                        <ExpressiveIcon
                            name={'on-demand-1'}
                            size={'medium'}
                            className={styles['expressive-icon']}
                        />
                    </div>
                    <div className={classNames(styles['preparation-summary-item-text'])}>
                        <span className="ud-heading-xxl" data-purpose={'learning-activities-taken'}>
                            {learningActivitiesTaken}
                        </span>
                        <span className="ud-text-md">{gettext('Learning activities taken')}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};
